import { newToolFilterOAuthMcp } from "../oauth.ts";

export const instantMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.instantdb.com/img/icon/apple-touch-icon-152x152.png",
  url: "https://mcp.instantdb.com/mcp",
  label: "Instant",
});
